// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymodesFooter_diet_container__b9dkY","title":"PaymodesFooter_diet_title__3y8gW"};